// Mill Lining Individual Solutions Service

import axios from "axios";
import endpoints from "@/api/endpoints";
import getLangCookie from "@/utils/get-lang-cookie";

export class MillLiningISService {
  static __instance = null;

  static LOCAL_KEYS = {
    STEPS: "ml_bo_calc",
    LANG: "ml_bo_calc_lang",
    EQUIPMENT_TYPE: "ml_bo_calc_equipment_type"
  };

  static REQUEST_PARAMS = {
    COMPANY_ID: "company_id",
    EQUIPMENT_ID: "equipment_id",
    TYPE_ID: "type_id"
  };

  constructor() {
    if (MillLiningISService.__instance) {
      return MillLiningISService.__instance;
    }
    this.lang = getLangCookie();

    MillLiningISService.__instance = this;
  }

  getLocalSteps() {
    return localStorage.getItem(MillLiningISService.LOCAL_KEYS.STEPS);
  }

  getLocalLang() {
    return localStorage.getItem(MillLiningISService.LOCAL_KEYS.LANG);
  }

  getLocalEquipmentType() {
    return localStorage.getItem(MillLiningISService.LOCAL_KEYS.EQUIPMENT_TYPE);
  }

  getParsedLocalSteps() {
    try {
      return JSON.parse(this.getLocalSteps());
    } catch {
      return null;
    }
  }

  setLocalSteps(val) {
    localStorage.setItem(
      MillLiningISService.LOCAL_KEYS.STEPS,
      JSON.stringify(val)
    );
  }

  setLocalLang() {
    localStorage.setItem(MillLiningISService.LOCAL_KEYS.LANG, this.lang);
  }

  setLocalEquipmentType(val) {
    localStorage.setItem(MillLiningISService.LOCAL_KEYS.EQUIPMENT_TYPE, val);
  }

  removeLocalSteps() {
    localStorage.removeItem(MillLiningISService.LOCAL_KEYS.STEPS);
  }

  hasLocalSteps() {
    return (
      Array.isArray(this.getParsedLocalSteps()) &&
      this.getParsedLocalSteps().length > 0 &&
      this.lang &&
      this.lang !== "undefined" &&
      this.lang !== "null" &&
      this.lang === this.getLocalLang()
    );
  }

  getTypesByCompany(companyID) {
    const { COMPANY_ID } = MillLiningISService.REQUEST_PARAMS;

    return axios
      .get(`${endpoints.millLining.typesByCompany}?${COMPANY_ID}=${companyID}`)
      .then(response => {
        if (response.data.success && response.data.types) {
          return response.data.types;
        } else throw new Error();
      });
  }

  getEquipmentByCompanyAndType(companyID, typeID) {
    const { COMPANY_ID, TYPE_ID } = MillLiningISService.REQUEST_PARAMS;

    return axios
      .get(
        `${endpoints.millLining.equipmentByCompanyAndType}?${COMPANY_ID}=${companyID}&${TYPE_ID}=${typeID}`
      )
      .then(response => {
        if (response.data.success && response.data.equipments) {
          return response.data.equipments;
        } else throw new Error();
      });
  }

  getForm(typeID) {
    const { TYPE_ID } = MillLiningISService.REQUEST_PARAMS;

    return axios
      .get(`${endpoints.millLining.form}?${TYPE_ID}=${typeID}`)
      .then(response => {
        if (response.data.success && response.data.equipmentForm) {
          return response.data.equipmentForm;
        } else throw new Error();
      });
  }

  sendForm(data) {
    return axios.post(`${endpoints.millLining.form}`, data).then(response => {
      if (response.data.success) {
        return response.data.file_link;
      } else throw new Error();
    });
  }
}

export const millLiningISService = new MillLiningISService();
